import React from 'react';

const Payment = () => {
    return (
        <div>
            <h1>Coming Soon!</h1>
        </div>
    );
};

export default Payment;